import { Pipe, PipeTransform } from '@angular/core';
import { environment } from '../../../environments/environment';
import { Planning } from '../../classes/planning.class';

type FieldGroup = 'fields_planning' | 'fields_planning_data' | 'fields_phe' | 'fields_phe_data';

/**
 * Resolves a planning field's stored key to its configured display name,
 * as defined in that entity type's field options.
 */
@Pipe({
    name: 'planningFieldValue',
    pure: false,
    standalone: false,
})
export class PlanningFieldValuePipe implements PipeTransform {
    /**
     * @return The option's display name, the raw stored value if no option matches,
     *         or the field's configured `nullValue` if there is no stored value at all.
     */
    transform(
        planning: Planning | undefined,
        fieldKey: string,
        prepend?: string,
        append?: string,
        fieldGroup: FieldGroup = 'fields_planning_data'
    ): string | undefined {
        const entityType = environment.entitytypes[planning?.mainPlanning?.entitytype_key];
        const field = entityType?.[fieldGroup]?.[fieldKey];
        const options = field?.options;
        const value = this.getFieldGroupValue(planning, fieldKey, fieldGroup);
        if (field?.displayCondition && !field.displayCondition(planning)) {
            return null;
        }

        const displayValue = options?.find(option => option.key === value)?.name ?? value ?? field?.nullValue;
        if (!displayValue) {
            return '';
        }
        return (prepend ?? '') + displayValue + (append ?? '');
    }

    private getFieldGroupValue(
        planning: Planning | undefined,
        fieldKey: string,
        fieldGroup: FieldGroup
    ): string | undefined {
        return {
            fields_planning: planning?.[fieldKey],
            fields_planning_data: planning?.data?.[fieldKey],
            fields_phe: planning?.mainPlanning?.[fieldKey],
            fields_phe_data: planning?.mainPlanning?.data?.[fieldKey],
        }[fieldGroup];
    }
}
